import { configureStore } from "@reduxjs/toolkit";

import common from "../features/admin/common/Slice";

import contactus from "./contactus";

import auth from "./auth";

import stay from "./stay";

import raise from "./raisefund";

import footer from "../features/admin/footer/Slice"

import donation from "../features/admin/donation/Slice"

import spandan from "../features/admin/spandan/Slice"

import commerce from "./commerce";

import wishlistReducer from "../features/wishlist/wishlistSlice";
import notificationReducer from "../features/notifications/notificationSlice";
import reviewRating from "../features/reviewRating/reviewRatingSlice";
import cartReducer from "../features/cart/cartSlice";
import orderReducer from "../features/order/orderSlice";

import userDonationDetails from "../features/admin/user_donation_details/Slice";

import volunteerstepform from "../features/admin/volunteerStepform/Slice"
import volunteers from "../features/admin/volunteerdetail/volunteer/Slice"

import myaccount from "../features/my_account/Slice";
import wallet from "../features/wallet/walletSlice";





export const store = configureStore({
  reducer: {
    common: common,
    footer: footer,
    spandan: spandan,

    contactus,
    auth,
    stay,
    raise,
    commerce,
    wishlist: wishlistReducer,
    notification: notificationReducer,
    reviewRating: reviewRating,
    cart: cartReducer,
    order: orderReducer,
    donation: donation,
    userDonationDetails: userDonationDetails,
    volunteerstepform: volunteerstepform,
    volunteers: volunteers,

    myaccount: myaccount,

    wallet: wallet,


  },
});
